import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('districtBankReconReport', [booksMenu])
  .controller('districtBankReconReportController', districtBankReconReportController)
  .name;
  
/* @ngInject */ function districtBankReconReportController($scope, BooksSvc, BusyScreen, Session) {
  /*------------------------------------------------*/
  /* Sets the default report format to PDF and the  */
  /* sorting of the report to be set to sortByTaxID */
  /*------------------------------------------------*/
  $scope.req = { reportFormat: 'PDF' };
  $scope.reportPage = Session.getSessionURL(
    '/DistrictBankReconReport.aspx'
  );

  /*--------------*/
  /* Get services */
  /*--------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;
    BusyScreen.setBusy(false);
  });
}